<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t}, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Addresse',
          text: 'Bernrainstrasse 1<br>8280 Kreuzlingen',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Telefon',
          text: '<a href="tel:+41716668000" target="_blank" style="color: inherit">+41 71 666 8000</a>',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: '<a href="mailto:info@ifea-treuhand.ch" target="_blank" style="color: inherit">info@ifea-treuhand.ch</a>',
        },
        {
          icon: 'mdi-clock-check-outline',
          title: 'Öffnungszeiten',
          text: '<p>Montag &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 13:30 - 17:30<br>Di - Do &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;08:30 - 12:00,<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;13:30 - 17:30 &nbsp;<br>Freitag &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;08:00 - 12:00</p>',
        },
      ],
    }),
  }
</script>
